function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function getVisibleAndHiddenActionsIndices() {
  var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var groups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var disclosureWidth = arguments.length > 2 ? arguments[2] : undefined;
  var actionsWidths = arguments.length > 3 ? arguments[3] : undefined;
  var containerWidth = arguments.length > 4 ? arguments[4] : undefined;
  var sumTabWidths = actionsWidths.reduce(function (sum, width) {
    return sum + width;
  }, 0);
  var arrayOfActionsIndices = actions.map(function (_, index) {
    return index;
  });
  var arrayOfGroupsIndices = groups.map(function (_, index) {
    return index;
  });
  var visibleActions = [];
  var hiddenActions = [];
  var visibleGroups = [];
  var hiddenGroups = [];
  if (containerWidth > sumTabWidths) {
    visibleActions.push.apply(visibleActions, _toConsumableArray(arrayOfActionsIndices));
    visibleGroups.push.apply(visibleGroups, _toConsumableArray(arrayOfGroupsIndices));
  } else {
    var accumulatedWidth = 0;
    arrayOfActionsIndices.forEach(function (currentActionsIndex) {
      var currentActionsWidth = actionsWidths[currentActionsIndex];
      if (accumulatedWidth + currentActionsWidth >= containerWidth - disclosureWidth) {
        hiddenActions.push(currentActionsIndex);
        return;
      }
      visibleActions.push(currentActionsIndex);
      accumulatedWidth += currentActionsWidth;
    });
    arrayOfGroupsIndices.forEach(function (currentGroupsIndex) {
      var currentActionsWidth = actionsWidths[currentGroupsIndex + actions.length];
      if (accumulatedWidth + currentActionsWidth >= containerWidth - disclosureWidth) {
        hiddenGroups.push(currentGroupsIndex);
        return;
      }
      visibleGroups.push(currentGroupsIndex);
      accumulatedWidth += currentActionsWidth;
    });
  }
  return {
    visibleActions: visibleActions,
    hiddenActions: hiddenActions,
    visibleGroups: visibleGroups,
    hiddenGroups: hiddenGroups
  };
}
export { getVisibleAndHiddenActionsIndices };